import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  IconButton,
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Tooltip,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
// import DynamicTable from "../../../../components/Dynamic-table";
import DynamicTable from "../../../../components/lab-dynamic-table";
import {
  getDefaultRecordDeleteTooltip,
  getDefaultRecordEditTooltip,
  isDefaultLabRecord,
} from "../../utils/defaultRecordActions";

import DeleteConfirmationModal from "../../../../components/Modals/delete-modal";

const TestParameters: React.FC<any> = () => {
  const [editData, setEditData] = useState(null);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState<any>("");
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [tableData, setTableData] = useState<any>();
  const [patientTypes, setPatientTypes] = useState<any[]>([]); // dropdown list
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [formData, setFormData] = useState({
    parameterName: "",
    parameterDescription: "",
    interpretation: "",
    parameterCharges: "",
    patientTypeIds: [] as string[],
  });

  const navigate = useNavigate();

  // debounce search
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchInput]);

  // const handleExcelFileUpload = async (
  //   e: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   if (!e.target.files || e.target.files.length === 0) return;

  //   const file = e.target.files[0];
  //   const data = new FormData();
  //   data.append("file", file);

  //   try {
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_LAB_URL}/parameters/fileUpload`,
  //       data, // 👈 send FormData
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data", // 👈 must be multipart
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     );
  //     console.log("excel file upload", res);
  //     toast.success(res.data.message);
  //   } catch (error) {
  //     console.error("Error uploading excel file", error);
  //   }
  // };

 

  // fetch patient types for dropdown
  const fetchPatientTypes = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_LAB_URL}/patient-type/getAllBySearch`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setPatientTypes(res.data?.data || []);
    } catch (error) {
      console.error("Error fetching patient types", error);
    }
  };

  // fetch table data
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_LAB_URL}/parameters/getAllByPagination`,
        {
          params: {
            pageNo: page + 1,
            count: rowsPerPage,
            search: debouncedSearch,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setTableData(response.data?.data);
      setTotal(response.data?.totalCount);
    } catch (error:any) {
      console.error("Error fetching data:", error);
      toast.error(error?.response.data.message || "Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, debouncedSearch]);
  useEffect(() => {
    fetchPatientTypes();
  }, []);
  // input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "parameterCharges"
          ? value === "" // allow empty input
            ? ""
            : Number(value.slice(0, 6))
          : value,
    }));
    setFormData((prev) => ({
      ...prev,
      [name]: name === "parameterCharges" ? Number(value.slice(0, 6)) : value,
    }));
  };

  // dropdown change
  const handlePatientTypeChange = (event: any) => {
    const { value } = event.target;

    if (value.includes("all")) {
      setFormData((prev) => ({
        ...prev,
        patientTypeIds:
          prev.patientTypeIds.length === patientTypes.length
            ? [] // ✅ Uncheck all
            : patientTypes.map((p) => p._id), // ✅ Select all
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        patientTypeIds: typeof value === "string" ? value.split(",") : value,
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      ///stg_lab/parameters/createParameter
      ///stg_lab/parameters/getAllByPagination
      ///stg_lab/parameters/updateById/{id}
      const url = editData
        ? `${process.env.REACT_APP_LAB_URL}/parameters/updateById/${editData}`
        : `${process.env.REACT_APP_LAB_URL}/parameters/createParameter`;

      const method = editData ? axios.patch : axios.post;

      const response = await method(
        url,
        { ...formData },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response?.data?.isSuccess) {
        toast.error(response?.data?.message);
      } else {
        toast.success(response?.data?.message);
        setFormData({
          parameterName: "",
          parameterDescription: "",
          interpretation: "",
          parameterCharges: "",
          patientTypeIds: [],
        });
        fetchData();
        setEditData(null);
      }
    } catch (error: any) {
      toast.error(error.message || "Something went wrong");
    }
  };

  const handleEditClick = (id: any, rowData: any) => {
    setEditData(id);
    setFormData({
      parameterName: rowData?.parameterName,
      parameterDescription: rowData?.parameterDescription,
      interpretation: rowData?.interpretation,
      parameterCharges: rowData?.parameterCharges,
      patientTypeIds: rowData?.patientTypeIds || [],
    });
  };
 const handleExcelFileUpload = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!e.target.files || e.target.files.length === 0) return;

    const file = e.target.files[0];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();

    if (!["xls", "xlsx"].includes(fileExtension || "")) {
      toast.error("Please upload a valid Excel file (.xls or .xlsx)");
      e.target.value = ""; // reset input if invalid
      return;
    }

    const data = new FormData();
    data.append("file", file);

    try {
      setUploading(true); // ✅ start loader

      const res = await axios.post(
        `${process.env.REACT_APP_LAB_URL}/import-data/fileUpload`,
        data,
        {
          params: {entity: "parameter"},
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success(res.data?.message || "File uploaded successfully");
      fetchData(); // Refresh data after successful upload

      e.target.value = ""; // reset input
    } catch (error: any) {
      console.error("❌ Error uploading excel file", error);
      toast.info(
        error.response?.data?.message ||
          error.message ||
          "Failed to upload file"
      );
      e.target.value = "";
    } finally {
      setUploading(false); // ✅ stop loader
    }
  };
  const handleDeleteClick = (id: any) => {
    setIsDeleteModalOpen(true);
    setSelectedItemId(id);
  };

  const handleDeleteConfirm = async () => {
    try {
      ///stg_lab/parameters/deleteById/{id}
      const response = await axios.delete(
        `${process.env.REACT_APP_LAB_URL}/parameters/deleteById/${selectedItemId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      fetchData();
      toast.success(response.data.message);
      setFormData({
        parameterName: "",
        parameterDescription: "",
        interpretation: "",
        parameterCharges: "",
        patientTypeIds: [],
      });
      setEditData(null);
    } catch (error: any) {
      toast.error(error.message);
    }
    setIsDeleteModalOpen(false);
  };

  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          borderRadius: 2,
          padding: "1px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
          }}
        >
          Test Parameters
        </Typography>
        <Box display="flex" alignItems="center" gap={1}>
          <TextField
            label="Search"
            placeholder="Search Parameter..."
            variant="outlined"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            // className="search-field"
            className="custom-input"
            size="small"
            InputProps={{
              endAdornment: (
                <IconButton>
                  <SearchIcon sx={{ color: "#055FFC" }} />
                </IconButton>
              ),
            }}
          />
        </Box>
      </Box>

      <Grid container spacing={1}>
        {/* Form */}
        <Grid item xs={12} sm={4} md={4}>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              p: 3,
              boxShadow: 1,
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              {editData ? "Update Parameter" : "Add New Parameter"}
            </Typography>

            <TextField
              size="small"
              label="Parameter Name"
              // className="search-field"
              className="custom-input"
              name="parameterName"
              value={formData.parameterName}
              fullWidth
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            {/* <FormControl
              fullWidth
              size="small"
              className="custom-input"
              sx={{
                mb: 2,
              }}
            >
              <InputLabel id="patient-type-label">Patient Types</InputLabel>

              <Select
                labelId="patient-type-label"
                multiple
                value={formData.patientTypeIds}
                onChange={handlePatientTypeChange}
                className="custom-input"
                renderValue={(selected) =>
                  patientTypes
                    .filter((p) => selected.includes(p._id))
                    .map((p) => p.patientTypeName)
                    .join(", ")
                }
              >
                <MenuItem
                  value="all"
                  sx={{
                    paddingTop: "0",
                    paddingBottom: "0",
                  }}
                >
                  <Checkbox
                    checked={
                      patientTypes.length > 0 &&
                      formData.patientTypeIds.length === patientTypes.length
                    }
                    sx={{ p: 0.5, transform: "scale(0.8)" }}
                  />
                  <ListItemText
                    primary="All"
                    primaryTypographyProps={{ fontSize: "0.8rem" }}
                  />
                </MenuItem>

                {patientTypes.map((pt) => (
                  <MenuItem
                    key={pt._id}
                    value={pt._id}
                    sx={{
                      // fontSize: "0.8rem",
                      paddingTop: "0",
                      paddingBottom: "0",
                    }}
                  >
                    <Checkbox
                      checked={formData.patientTypeIds.includes(pt._id)}
                      sx={{ p: 0.5, transform: "scale(0.8)" }}
                    />
                    <ListItemText
                      primary={pt.patientTypeName}
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            
            <TextField
              size="small"
              className="custom-input"
              label="Description"
              name="parameterDescription"
              value={formData.parameterDescription}
              fullWidth
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <TextField
              size="small"
              // className="search-field"
              className="custom-input"
              type="number"
              name="parameterCharges"
              label="Parameter Charges"
              // value={formData.parameterCharges || ""}
              value={
                formData.parameterCharges === undefined
                  ? ""
                  : formData.parameterCharges
              }
              fullWidth
              onChange={handleChange}
              sx={{ mb: 2 }}
              InputProps={{
                endAdornment: (
                  <Typography sx={{ color: "grey" }}>RS</Typography>
                ),
              }}
            />
            <TextField
              size="small"
              label="Interpretation"
              name="interpretation"
              className="custom-input"
              value={formData.interpretation}
              onChange={handleChange}
              fullWidth
              multiline
              // maxRows={3}
              rows={3}
              sx={{
                mb: 2,
                borderRadius: "10px",
                "& .MuiInputBase-root": {
                  backgroundColor: "#fff",
                },
                "& .MuiOutlinedInput-root": {
                  border: "none",
                  outline: "none",
                },
                "& fieldset": { border: "none" },
                "& textarea": {
                  resize: "both",
                  maxHeight: "80px",
                },
              }}
            />

            <Button
              variant="contained"
              color="primary"
              fullWidth
              // className="search-field"
              className="custom-input"
              onClick={handleSubmit}
              disabled={
                !formData.parameterName ||
                !formData.patientTypeIds ||
                formData.parameterCharges === "" ||
                formData.parameterCharges === undefined
              }
            >
              {editData ? "Update" : "Save"}
            </Button>

            <div className="w-full mt-4 flex justify-between items-center gap-2">
              <div>
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  id="excel-upload"
                  onChange={handleExcelFileUpload}
                  style={{ display: "none" }} // hide the default file input
                />
                <label htmlFor="excel-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    disabled={uploading} // ✅ disable while uploading
                    startIcon={
                      uploading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <img
                          src="/excel-logo.png"
                          alt="Excel File"
                          style={{ width: 24, height: 24 }}
                        />
                      )
                    }
                    sx={{
                      textTransform: "none",
                      borderRadius: "10px",
                      padding: "8px 16px",
                    }}
                  >
                    {uploading
                      ? "Uploading..."
                      : "Import Excel File (.xls / .xlsx)"}
                  </Button>
                </label>
              </div>
              <Tooltip arrow placement="top" title="Download Excel Template">
                <IconButton
                  sx={{
                    // backgroundColor: "blue",
                    color: "white",
                    "&:hover": {
                      // backgroundColor: "darkgreen",
                    },
                  }}
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = "/Parameter Template.xlsx";
                    link.download = "Parameter Template.xlsx";
                    link.click();
                  }}
                >
                  {/* <DescriptionIcon /> */}
                  <img
                    src="/export-excel.png" // ✅ directly from public folder
                    alt="Excel File"
                    style={{ width: 30, height: 30 }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          </Box>
        </Grid>

        {/* Table */}
        <Grid item xs={12} sm={8} md={8}>
          <DynamicTable
            headers={[
              "SN",
              "Name",
              // "Description",
              "Interpretation",
              "Charges",
              // "Patient Types",
              "Description",
              "Actions",
            ]}
            data={tableData?.map((item: any, index: any) => [
              page * rowsPerPage + index + 1,
              item?.parameterName || "",
              // item?.parameterDescription || "",
              item?.interpretation || "",
              item?.parameterCharges || 0,
              // item?.patientTypeIds
              //   ?.map(
              //     (id: string) =>
              //       patientTypes.find((pt) => pt._id === id)?.patientTypeName
              //   )
              //   .join(", "),
              item?.parameterDescription || "",
            ])}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            handleChangePage={(e, newPage) => setPage(newPage)}
            handleChangeRowsPerPage={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setPage(0);
            }}
            totalRows={total}
            actionButtons={[
              {
                icon: <EditIcon sx={{ color: "#FFB800", cursor: "pointer" }} />,
                onClick: (rowIndex: any) =>
                  handleEditClick(
                    tableData[rowIndex]?._id,
                    tableData[rowIndex]
                  ),
                disabled: (rowIndex) => isDefaultLabRecord(tableData[rowIndex]),
                tooltip: (rowIndex) =>
                  getDefaultRecordEditTooltip(tableData[rowIndex]),
              },
              {
                icon: (
                  <DeleteIcon sx={{ color: "#FF5454", cursor: "pointer" }} />
                ),
                onClick: (rowIndex: any) =>
                  handleDeleteClick(tableData[rowIndex]?._id),
                disabled: (rowIndex) => isDefaultLabRecord(tableData[rowIndex]),
                tooltip: (rowIndex) =>
                  getDefaultRecordDeleteTooltip(tableData[rowIndex]),
              },
              
            ]}
            height={"60vh"}
          />
        </Grid>
      </Grid>

      <DeleteConfirmationModal
        open={isDeleteModalOpen}
        handleClose={() => setIsDeleteModalOpen(false)}
        handleConfirm={handleDeleteConfirm}
      />
    </Box>
  );
};

export default TestParameters;
